import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Popover, Spin } from "antd";
import { Icon } from "@terminus/dqh-web-ui";
import { getWxQrCode } from "@/services/basic";
import styleCss from "./index.module.scss";

type WxShareProps = {
  params: {
    page: string;
    scene: string;
    env_version: string;
    check_path?: boolean;
    width?: number;
    operationType?: string;
    creditCode?: string;
  };
  label?: string;
  style?: React.CSSProperties;
  shareText: string;
};

export default function WxShare(props: WxShareProps) {
  const [wxQrCode, setWxQrCode] = useState("");
  const { params, label, style, shareText } = props;

  const PopoverContent = useMemo(() => {
    return (
      <Spin spinning={!wxQrCode}>
        <div
          style={{
            textAlign: "center",
            fontSize: 13,
            color: "rgba(74, 74, 76, 1)",
          }}
        >
          {wxQrCode && (
            <>
              <img
                src={`data:image/jpeg;base64,${wxQrCode}`}
                alt="wxQrCode"
                width={120}
                style={{ marginBottom: 6 }}
              />
              <div>微信扫码分享</div>
              <div>{shareText}</div>
            </>
          )}
        </div>
      </Spin>
    );
  }, [wxQrCode]);

  const handleOpenChange = useCallback(
    (e: boolean) => {
      if (e && !wxQrCode && params?.page && params?.scene) {
        getWxQrCode(params).then((res: any) => {
          setWxQrCode(res.qrcode);
        });
      }
    },
    [wxQrCode, params]
  );

  return (
    <Popover
      content={PopoverContent}
      trigger="click"
      placement="bottom"
      onOpenChange={(e) => handleOpenChange(e)}
    >
      <div className={styleCss.operateItem} style={style}>
        <Icon name="fenxiangqiye1" size={14} color="#777779" />
        {label ? label : "分享"}
      </div>
    </Popover>
  );
}
